import React, { useEffect, useState } from "react";
import {
  DEMO_TYPE,
  MONTHLY_TYPE,
  RETAKE_TYPE,
  SLOT_STATUSES,
  STATUS_AVAILABLE,
  STUDENT_ROLE,
  TEACHER_ROLE,
  TEACHING_MODE,
  offerStatuses,
} from "../../constants";
import {
  addDocToFirestore,
  convertTo12HourFormat,
  formatChatDate,
  groupSlotsByDate,
  reactToast,
} from "../../helper";
import PopOverMenu from "../pop-over-menu/pop-over-menu";
import { fetchOfferSlots } from "../../services/teacher";
import { useSelector } from "react-redux";
import {
  fetchOfferSlotsByOfferSlotId,
  updateMeetingSlotStatus,
} from "../../services/offer-slots";
import Modal from "../modal";
import { Rate } from "antd";
import CreateOfferCard from "../createOfferCard/CreateOfferCard";
import { toast } from "react-toastify";

export const OfferCard = ({ offerDetail }) => {
  const initReviewAndRating = {
    review: null,
    rating: null,
    slotId: 0,
  };

  const currentUser = useSelector((state) => state.auth.user);
  const [detail, setDetail] = useState();

  const [loading, setLoading] = useState(false);
  const [slotUpdateStatusLoading, setSlotUpdateStatusLoading] = useState(false);
  const [reviewModal, setReviewModal] = useState(false);
  const [reviewAndRatingDetail, setReviewAndRatingDetail] = useState({
    ...initReviewAndRating,
  });

  const [openOfferCard, setOpenOfferCard] = useState(false);

  const [retakeOfferDetail, setRetakeOfferDetail] = useState();
  const [trackDetail, setTrackDetail] = useState();

  useEffect(() => {
    console.log("detail", detail);
  }, [detail]);

  useEffect(() => {
    if (offerDetail) {
      console.log("offerDetail", offerDetail);
      setDetail({ ...offerDetail });
      setRetakeOfferDetail({ ...offerDetail });
    }
  }, [offerDetail]);

  // const [newMessage, setNewMessage] = useState("");

  // new Funcitionality to send message
  const sendMessage = async (message, offerData) => {
    try {
      if (message.trim() === "") return;
      setLoading(true);
      // setNewMessage("");
      const userID = currentUser?.uuid;
      const receiverID = retakeOfferDetail?.teacher?.uuid;
      let messageBody = {};

      // is offer type
      if (openOfferCard) {
        messageBody = {
          text: message,
          sender_uuid: userID,
          senderName: currentUser?.fullName,
          receiver_uuid: receiverID,
          // receiverId: receiver?.id,
          // receiverName: receiver?.fullName,
          receiverId: retakeOfferDetail?.teacherId,
          receiverName: retakeOfferDetail?.teacher?.fullName,

          timestamp: new Date(),
          seen: false,

          offerDetail: offerData,
        };
      } else {
        messageBody = {
          text: message,
          sender_uuid: userID,
          senderName: currentUser?.fullName,
          receiver_uuid: receiverID,
          // receiverId: receiver?.id,
          // receiverName: receiver?.fullName,
          receiverId: retakeOfferDetail?.teacherId,
          receiverName: retakeOfferDetail?.teacher?.fullName,
          timestamp: new Date(),
          seen: false,
        };
      }
      // setMessages([messageBody, ...messages]);
      // scrollToBottom();
      // await addDocToFirestore(currentUser?.uuid, receiver?.uuid, messageBody);
      await addDocToFirestore(
        currentUser?.uuid,
        retakeOfferDetail?.teacher?.uuid,
        messageBody
      );

      setLoading(false);
    } catch (error) {
      toast.error("Message is not sent, try again");
      console.error("Error sending message:", error);
      setLoading(false);
    }
  };

  const sendOffer = async (offerData) => {
    try {
      // await sendMessage("New Offer Request", {
      //   ...offerData,
      //   offerStatus: offerStatuses.PENDING,
      // });
      await sendMessage("Retake Offer Request", {
        ...offerData,
        offerStatus: offerStatuses.PENDING,
      });
      if (openOfferCard) {
        handleCreateOfferCardModal(MONTHLY_TYPE);
      }
    } catch (error) {}
  };

  const handleCreateOfferCardModal = (offerType, slots) => {
    setOpenOfferCard(!openOfferCard);
    if (offerType) {
      setRetakeOfferDetail({
        ...retakeOfferDetail,
        offerType,
        retakeSlotId: slots[0]?.id,
      });
    }

    // else {
    //   setRetakeOfferDetail({ ...retakeOfferDetail });
    // }
  };

  const getOfferSlots = async (teacherId, offerId) => {
    try {
      setLoading(true);
      const { data, status } = await fetchOfferSlots(teacherId, offerId);
      if (status === 200) {
        if (data?.data?.length) {
          setDetail((prev) => ({
            ...prev,
            slots: data?.data,
          }));
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getTrackDetail = async (offerSlotID) => {
    try {
      setLoading(true);
      const { data, status } = await fetchOfferSlotsByOfferSlotId(offerSlotID);
      if (status === 200) {
        setTrackDetail(data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const reviewAndRating = (offer, slot) => {
    setReviewAndRatingDetail((preState) => ({
      ...preState,
      slotId: slot?.id,
    }));
    setReviewModal(true);
  };

  const handleCanclereviewModal = () => {
    let temp = { ...reviewAndRatingDetail };
    temp.rating = null;
    temp.review = null;
    setReviewAndRatingDetail(temp);
    // setReviewAndRatingDetail(preState => ({
    //   ...preState,
    //   review: null,
    //   rating: null,
    // }))
    setReviewModal(false);
    // handleReviewAndRatingSubmit(temp)
  };

  useEffect(() => {}, [reviewAndRatingDetail]);

  const handleReviewAndRatingSubmit = async (reviewDetail) => {
    setReviewModal(false);

    try {
      setSlotUpdateStatusLoading(true);
      let payload = {
        status: SLOT_STATUSES.COMPLETED,
        review: reviewDetail.review,
        rating: reviewDetail.rating,
        teacherId: offerDetail?.teacherId,
      };
      const { data, status } = await updateMeetingSlotStatus(
        reviewDetail.slotId,
        payload
      );
      if (status === 200) {
        reactToast("success", data?.message);
        let temp = { ...detail };
        let findSlot = temp?.slots?.find(
          (item) => Number(item?.id) === Number(reviewDetail.slotId)
        );
        if (findSlot) {
          findSlot.status = SLOT_STATUSES.COMPLETED;
          setDetail(temp);
        }
        // await getOfferSlots(offer?.teacherId, offer?.id);
      } else {
        reactToast("error", data?.message);
      }
      setSlotUpdateStatusLoading(false);
      setReviewAndRatingDetail({ ...initReviewAndRating });
    } catch (error) {
      setSlotUpdateStatusLoading(false);
    }
  };

  const updateSlotStatus = async (offer, slot) => {
    try {
      setSlotUpdateStatusLoading(true);
      let payload = {
        status: SLOT_STATUSES.COMPLETED,
      };
      const { data, status } = await updateMeetingSlotStatus(slot?.id, payload);
      if (status === 200) {
        reactToast("success", data?.message);
        let temp = { ...detail };
        let findSlot = temp?.slots?.find(
          (item) => Number(item?.id) === Number(slot?.id)
        );
        if (findSlot) {
          findSlot.status = SLOT_STATUSES.COMPLETED;
          setDetail(temp);
        }
        // await getOfferSlots(offer?.teacherId, offer?.id);
      } else {
        reactToast("error", data?.message);
      }
      setSlotUpdateStatusLoading(false);
    } catch (error) {
      setSlotUpdateStatusLoading(false);
    }
  };

  const renderSlots = (slots) => {
    if (loading) return "Loading...";
    if (!slots) return "No slots available";
    return Object.entries(groupSlotsByDate(slots))?.map(([date, slots]) => {
      return (
        <div key={date} className="border-bottom py-1">
          <b>
            <span className="d-block">
              {" "}
              {`${date} - ${slots[0]?.dayName}`} {`(${slots?.length})`}
            </span>
          </b>

          <SlotList slots={slots} />
        </div>
      );
    });
  };

  const renderTrackDetail = () => {
    // return Object.entries(groupSlotsByDate(slots))?.map(([date, slots]) => {
    if (loading) return "Loading...";

    return (
      <div className="mt-2 fs_12">
        <div>
          <b>Offer Type:</b> {trackDetail?.offer?.offerType}
        </div>
        <div>
          <b>Teaching Mode:</b> {trackDetail?.offer?.teachingMode}
        </div>
        <div>
          <b>Date:</b> {trackDetail?.date}
        </div>
        <div>
          <b>Price:</b> {trackDetail?.offer?.price}
        </div>
        <div>
          <b>Subjects Requested: </b>
          {trackDetail?.offer?.offerSubjects.length
            ? trackDetail?.offer?.offerSubjects?.map((cur, i) =>
                i === trackDetail?.offer?.offerSubjects.length - 1 ? (
                  <span key={i}>{cur?.subjectName}</span>
                ) : (
                  <span key={i}>{cur?.subjectName},</span>
                )
              )
            : "N/A"}
        </div>
      </div>
    );
    // });
  };

  const SlotList = ({ slots }) => (
    <ul>
      {slots.map((slot) => (
        <li key={slot.uuid}>
          <span className="d-block">
            <span className="d-inline-block" style={{ minWidth: "135px" }}>
              {`${convertTo12HourFormat(
                slot?.startTime
              )} - ${convertTo12HourFormat(slot?.endTime)}`}
            </span>

            {slot?.status &&
              (slot?.status === SLOT_STATUSES.DELIVERED ? (
                <span className="badge text-capitalize text-bg-warning ms-2">
                  {slot?.status}
                </span>
              ) : slot?.status === SLOT_STATUSES.COMPLETED ? (
                <span className="badge text-capitalize text-bg-success ms-2">
                  {slot?.status}
                </span>
              ) : slot?.status !== STATUS_AVAILABLE ? (
                <span className={`badge text-capitalize text-bg-danger ms-2`}>
                  {slot?.status}
                </span>
              ) : (
                <span className={`badge text-capitalize text-bg-success ms-2`}>
                  {slot?.status}
                </span>
              ))}
          </span>
          {currentUser?.role === STUDENT_ROLE &&
          offerDetail?.status === offerStatuses.ACCEPTED &&
          slot?.status !== SLOT_STATUSES.COMPLETED &&
          slot?.status === SLOT_STATUSES.DELIVERED ? (
            // true
            <>
              <div className="form-check">
                <input
                  disabled={slotUpdateStatusLoading}
                  // onChange={() => updateSlotStatus(offerDetail, slot)}
                  onChange={() => reviewAndRating(offerDetail, slot)}
                  name={"teachingMode"}
                  className="form-check-input"
                  type="checkbox"
                />
                <label
                  className="form-check-label fs_12 text-danger"
                  htmlFor="cityCheckbox1"
                >
                  Mark as Completed
                </label>
              </div>
              <div className="form-check">
                <label
                  className="form-check-label fs_12 text-danger cursor_pointer"
                  htmlFor="cityCheckbox1"
                  onClick={() => handleCreateOfferCardModal(RETAKE_TYPE, slots)}
                >
                  Request to Retake
                </label>
              </div>
            </>
          ) : (
            ""
          )}
          {currentUser?.role === TEACHER_ROLE &&
          offerDetail?.status === offerStatuses.ACCEPTED &&
          slot?.status !== SLOT_STATUSES.COMPLETED &&
          slot?.status === SLOT_STATUSES.DELIVERED ? (
            <span className="text-danger">Not yet completed by Student</span>
          ) : (
            ""
          )}
        </li>
      ))}
    </ul>
  );

  // function groupSlotsByDate(slots) {
  //   const groupedSlots = {};

  //   slots?.forEach((slot) => {
  //     const date = slot.date;
  //     if (!groupedSlots[date]) {
  //       groupedSlots[date] = [];
  //     }
  //     groupedSlots[date].push(slot);
  //   });

  //   return groupedSlots;
  // }

  return (
    <>
      {/* offer card modal */}
      <CreateOfferCard
        // zIndex={10000}
        open={openOfferCard}
        setOfferDetail={setRetakeOfferDetail}
        offerDetail={retakeOfferDetail}
        // when offer will send by student
        teacherId={retakeOfferDetail?.teacherId}
        studentId={currentUser?.id}
        onSendOffer={sendOffer}
        handleOk={handleCreateOfferCardModal}
        handleCancel={handleCreateOfferCardModal}
      />

      {reviewModal ? (
        <Modal
          zIndex={10000}
          title={"Please Rate"}
          show={reviewModal}
          onCancel={handleCanclereviewModal}
        >
          <h6>Rating</h6>
          <Rate
            // allowHalf
            defaultValue={2}
            value={reviewAndRatingDetail?.rating}
            onChange={(e) =>
              setReviewAndRatingDetail((preState) => ({
                ...preState,
                rating: e,
              }))
            }
            style={{ fontSize: "17px" }}
          />
          <h6 className="mt-3">Review</h6>
          <textarea
            name=""
            id=""
            cols="10"
            rows="4"
            className="form-control mb-3"
            autoFocus
            value={reviewAndRatingDetail?.review}
            onChange={(e) =>
              setReviewAndRatingDetail((preState) => ({
                ...preState,
                review: e.target.value,
              }))
            }
          ></textarea>

          {/* <p>
              <>
                <span className="d-block">
                  Are you sure you want to disable experties?
                </span>
                <span className="d-block">
                  It will no longer be available to new students, except for
                  those who have already enrolled.
                </span>
              </>
              <p>Are you sure you want to enabel experties?</p>
          </p> */}

          <div className="d-flex justify-content-end">
            <button
              onClick={handleCanclereviewModal}
              disabled={loading}
              className="btn btn_outlined me-2"
            >
              Cancel
            </button>
            <button
              onClick={(e) =>
                handleReviewAndRatingSubmit(reviewAndRatingDetail)
              }
              disabled={loading}
              className="btn btn-primary btn_contained"
            >
              {/* {loading ? <Loader /> : "Proceed"} */}
              Proceed
            </button>
          </div>
        </Modal>
      ) : (
        ""
      )}

      <div className="row mb-1">
        <div className="col-6">
          <strong>Offer Type:</strong>
        </div>
        <div className="col-6 ">
          <span
            className={`text-capitalize badge ${
              detail?.offerType === DEMO_TYPE ? "text-bg-warning" : "bg-primary"
            }`}
          >
            {detail?.offerType}
          </span>
        </div>
      </div>
      <div className="row mb-1">
        <div className="col-6">
          <strong>Teaching Mode:</strong>
        </div>
        <div className="col-6 ">
          <span
            className={`text-capitalize badge ${
              detail?.teachingMode === TEACHING_MODE.HOME
                ? "text-bg-success"
                : "text-bg-secondary"
            } `}
          >
            {detail?.teachingMode || "N/A"}
          </span>
        </div>
      </div>
      {detail?.offerType === MONTHLY_TYPE ? (
        <div className="row mb-1">
          <div className="col-6">
            <strong>Duration:</strong>
          </div>
          <div className="col-6 font-size-12px">
            {`${formatChatDate(detail?.startDate)} - ${formatChatDate(
              detail?.endDate
            )}`}
          </div>
        </div>
      ) : (
        <div className="row mb-1">
          <div className="col-6">
            <strong>Date:</strong>
          </div>
          <div className="col-6 font-size-12px">
            {formatChatDate(detail?.startDate)}
          </div>
        </div>
      )}
      <div className="row mb-1">
        <div className="col-6">
          <strong>Price:</strong>
        </div>
        <div className="col-6">PKR: {detail?.price}</div>
      </div>
      <div className="row mb-1">
        <div className="col-12">
          <strong>Subjects Requested:</strong>
        </div>
        <div className="col-12">
          {detail?.subjects?.length
            ? detail?.subjects?.map((subject, index) => (
                <div key={index} className="d-inline-block me-2 mb-1">
                  <span className="me-2 fs_12">{subject?.subjectName}</span>
                  <span className="badge bg-primary">{subject?.levelName}</span>
                </div>
              ))
            : "N/A"}
        </div>
      </div>

      <div className="row mb-1">
        <div className="col-12">
          <strong>Other Subjects:</strong>
        </div>
        <div className="col-12">
          {detail?.extraSubjects?.length
            ? detail?.extraSubjects?.map((subject, index) => (
                <div key={index} className="d-inline-block me-2 mb-1">
                  <span className="badge bg-primary">
                    {subject?.subjectName}
                  </span>
                </div>
              ))
            : "N/A"}
        </div>
      </div>

      <div className="row mb-1">
        <div className="col-12">
          {detail?.slots?.length ? (
            <PopOverMenu
              placement="bottom"
              content={
                <div
                  style={{
                    minHeight: "100px",
                    maxHeight: "300px",
                    overflowY: "scroll",
                    padding: "0px 10px",
                  }}
                >
                  <div>
                    <u>
                      <b>
                        Total Days:{" "}
                        {`(${
                          Object.entries(groupSlotsByDate(detail?.slots))
                            ?.length
                        })`}
                      </b>
                    </u>
                  </div>
                  {renderSlots(detail?.slots)}
                </div>
              }
              button={
                <u>
                  <span
                    onClick={() => {
                      getOfferSlots(offerDetail?.teacherId, offerDetail?.id);
                    }}
                    className="fs_12"
                  >
                    View Slots
                  </span>
                </u>
              }
            />
          ) : (
            ""
          )}

          {/* track details */}

          <div>
            {detail?.offerType === RETAKE_TYPE ? (
              <PopOverMenu
                placement="bottom"
                content={
                  <div
                    style={{
                      minHeight: "100px",
                      maxHeight: "300px",
                      overflowY: "scroll",
                      padding: "0px 10px",
                    }}
                  >
                    <div>
                      <u>
                        <b>
                          Details:{" "}
                          {/* {`(${
                          Object.entries(groupSlotsByDate(detail?.slots))
                            ?.length
                        })`} */}
                        </b>
                      </u>
                    </div>
                    {renderTrackDetail()}
                  </div>
                }
                button={
                  <u>
                    <span
                      onClick={() => {
                        getTrackDetail(detail?.offerSlots[0]?.offerSlotId);
                      }}
                      className="fs_12"
                    >
                      Track Details
                    </span>
                  </u>
                }
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferCard;
